import React from 'react';
import { Col } from 'antd';

import TwoColumns from '../TwoColumns';
import Image from '../Image';

export const ImageHeadedTwoColumns = ({ value, ...props }) => (
  <React.Fragment>
    <Col><Image {...props} value={value.image} /></Col>
    <TwoColumns {...props} value={value} />
  </React.Fragment>
);

export default ImageHeadedTwoColumns;



// WEBPACK FOOTER //
// ./src/modules/CMS/components/ImageHeadedTwoColumns/index.js